import svgUrl from "ni:svgr;U-OWVkFctyTfQ9XzQSZ2DgSaaQvCyH2gaesVwbWZGio";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiUnpivotSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M7 3h6v3H7V3ZM6 3H3v3h3V3Zm0 4H3v6h3V7ZM2 6V3a1.013 1.013 0 0 1 .134-.5A1.005 1.005 0 0 1 3 2h10a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H7v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6Zm11 2.5a.5.5 0 0 1 1 0V9a5 5 0 0 1-4.715 4.992l.569.569a.5.5 0 0 1-.708.707l-1.414-1.415a.5.5 0 0 1 0-.707l1.414-1.414a.5.5 0 0 1 .708.707l-.55.55A4 4 0 0 0 13 9H13v-.5Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiUnpivotSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiUnpivotSIcon)";
}